import { render } from "./search-box-results.vue?vue&type=template&id=fad4e238&scoped=true&lang=pug"
import script from "./search-box-results.vue?vue&type=script&lang=js"
export * from "./search-box-results.vue?vue&type=script&lang=js"

import "./search-box-results.vue?vue&type=style&index=0&id=fad4e238&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fad4e238"]])

export default __exports__